// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'

Vue.use(element)

import IntvTimeCale from './components/IntvTimeCale.vue';
import eventBus from "../../../../../../util/eventBus";
import {utils} from "./common/common";

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', this.model.style, props)
            setHtml(this.model, props)
        },
        update: function (props) {
            // updateHtml(this.model, props)
            eventBus.pub(this.model, 'update', props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props) => {
        KDApi.loadFile('./css/index.css', model, () => {
            const {invoke, dom} = model
            Vue.prototype.getLangMsg = (key, configObj) => {
                return KDApi.getLangMsg(model, key, configObj)
            }
            Vue.prototype.getZeroTime = (val) =>{
                let time = val ? new Date(val) : new Date();
                return new Date(time.getFullYear() + '/' + (time.getMonth()+1) + '/' + time.getDate()).getTime();
            }
            new Vue({
                el: model.dom,
                template: '<IntvTimeCale :invoke="invoke" :customDataObj="customDataObj" :customEvtName="customEvtName" :themeNum="themeNum" :lang="lang" />',
                components: {
                    IntvTimeCale
                },
                data: {
                    customDataObj: {},
                    customEvtName: '',
                    themeNum:"#5582F3",
                    lang:"zh_CN"
                },
                destoryed() {
                    console.log('Vue destory')
                },
                mounted() {
                    if(props.themeNum){this.themeNum = props.themeNum;}
                    if(props.lang){this.lang = props.lang;}
                    this.updateSub = eventBus.sub(model, 'update', (props) => {
                        if(props.themeNum){this.themeNum = props.themeNum;}
                        if(!props.data){return}
                        if (props.data.hasOwnProperty('customEvtName')) {
                            this.customEvtName = props.data.customEvtName
                        }
                        if(props.data.hasOwnProperty('customDataObj')){
                            this.customDataObj = props.data.customDataObj ? JSON.parse(props.data.customDataObj) : {};
                        }
                    })
                    // this.customDataObj = {
                    //     "pageState": "view",
                    //     "noPromptTipFlag": false,
                    //     "pkId": 1218858296862071808,
                    //     "ableInterviewTime": [
                    //         {
                    //             "interviewDate": "2021-08-26",
                    //             "periodList": [
                    //                 {
                    //                     "startTime": "2021-08-26 09:35:27",
                    //                     "endTime": "2021-08-26 10:35:29"
                    //                 }
                    //             ]
                    //         },
                    //         {
                    //             "interviewDate": "2021-08-27",
                    //             "periodList": [
                    //                 {
                    //                     "startTime": "2021-08-27 06:13:15",
                    //                     "endTime": "2021-08-27 07:13:25"
                    //                 },
                    //                 {
                    //                     "startTime": "2021-08-27 09:21:11",
                    //                     "endTime": "2021-08-27 11:18:15"
                    //                 }
                    //             ]
                    //         },
                    //         {
                    //             "interviewDate": "2021-08-30",
                    //             "periodList": [
                    //                 {
                    //                     "startTime": "2021-08-30 06:13:31",
                    //                     "endTime": "2021-08-30 06:13:34"
                    //                 }
                    //             ]
                    //         }
                    //     ],
                    //     "unableInterviewTime": [
                    //         {
                    //             "interviewDate": "2021-08-23",
                    //             "periodList": [
                    //                 {
                    //                     "startTime": "2021-08-23 06:13:15",
                    //                     "endTime": "2021-08-23 07:13:25"
                    //                 },
                    //                 {
                    //                     "startTime": "2021-08-23 09:21:11",
                    //                     "endTime": "2021-08-23 12:18:15"
                    //                 }
                    //             ]
                    //         },
                    //         {
                    //             "interviewDate": "2021-08-26",
                    //             "periodList": [
                    //                 {
                    //                     "startTime": "2021-08-26 06:13:31",
                    //                     "endTime": "2021-08-26 16:13:34"
                    //                 }
                    //             ]
                    //         },
                    //         {
                    //             "interviewDate": "2021-08-29",
                    //             "periodList": [
                    //                 {
                    //                     "startTime": "2021-08-29 10:21:42",
                    //                     "endTime": "2021-08-29 12:17:49"
                    //                 }
                    //             ]
                    //         }
                    //     ],
                    //     "selected": false
                    // }
                },
                methods: {
                    invoke: function (eventName, args) {
                        invoke(eventName, args)
                    }
                }
            })
        })
    }

    // 注册自定义组件
    KDApi.register('setIntvTime', MyComponent,{
        isMulLang: true
    })
})(window.KDApi)
